module.exports = __webpack_public_path__ + "img/SC-3799.c0fc2679.png";